import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Drawer, Grid2, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { CaseInfoManage } from './_components/case-infoManage';
import { CaseInvoicesManage } from './_components/case-invoices';
import { CaseSubjectManage } from './_components/case-subjectManage';

export const CaseManageDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void }) => {

    const { id } = useParams<{ id: string }>();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    const [tab, setTab] = useState('1');

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setTab(newValue);
    };

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={(!!id) ? "Update Case" : "Create Case"} onClose={params.onClose} />

            <TabContext value={tab}>
                <Grid2 size={{ xs: 12 }} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                        <Tab label="Case" value="1" />
                        {(!!id) && <Tab label="Subjects" value="2" />}
                        {(!!id) && <Tab label="Invoices" value="3" />}
                    </TabList>
                </Grid2>

                <Grid2 size={{ xs: 12 }}>
                    <TabPanel value="1" sx={{ p: 0, m: 0 }}>
                        <CaseInfoManage onSave={params.onSave} />
                    </TabPanel>
                    <TabPanel value="2" sx={{ p: 0, m: 0 }}>
                        <CaseSubjectManage />
                    </TabPanel>
                    <TabPanel value="3" sx={{ p: 0, m: 0 }}>
                        <CaseInvoicesManage />
                    </TabPanel>
                </Grid2>

            </TabContext>
        </Drawer>
    );
};